// tamanho fixo do menu lateral do projeto (px confirmado com o UX/UI)
export const collapsedLeftContainerWidth = '64px'
export const expandedLeftContainerWidth = '214px'

export const collapsedSidePanelWidth = '45px'
export const expandedSidePanelWidth = '100%'

export const TopContainerHeight = '64px'
